// Automatisch generiert von scripts/generate-version.js - NICHT manuell bearbeiten.
// Wird vor jedem Build (prebuild) und bei jedem "npm version" Bump neu geschrieben.
// Versionsbump ausschliesslich ueber: npm version patch|minor|major
export const appVersion = {
  version: '1.66.1',
  buildNumber: 156,
};
